import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { BackendUnreachable } from '@/components/backend-unreachable';
import { useCurrentUser } from '@/features/auth/hooks/use-current-user';

const KIOSK_LANDING_PATH = '/finance/gmv';

function isKioskAllowed(pathname: string): boolean {
  return pathname === KIOSK_LANDING_PATH || pathname.startsWith(`${KIOSK_LANDING_PATH}/`);
}

export function InvestorGate({ children }: { readonly children: ReactNode }) {
  const { isLoading, isBackendUnreachable, isInvestorOnly } = useCurrentUser();
  const location = useLocation();

  // Every route under the shell passes through this gate, so this one branch
  // covers the whole app while the local backend boots or restarts.
  if (isBackendUnreachable) return <BackendUnreachable />;
  if (isLoading) return null;
  if (isInvestorOnly && !isKioskAllowed(location.pathname)) {
    return <Navigate to={KIOSK_LANDING_PATH} replace />;
  }
  return <>{children}</>;
}
